export const RUNS_FILTER_DEFAULT_KEYS = [
  'run:displayName',
  'tags:-',
  'run:state',
  // 'run:name' is actually 'run:id
  // it's very confusing why this is aliased to Name, but this goes back 4+ years
  // see explicit aliasing here: src/util/runs.ts
  'run:name',
  'run:createdAt',
  'run:updatedAt',
  'run:duration',
  'run:username',
  'run:sweep',
  'run:group',
  'run:jobType',
  'run:host',
  'run:commit',
];
